export default "__VITE_ASSET__8731f1c2__"